import { render } from "./ReceiptTemplate.vue?vue&type=template&id=6d6239aa"
import script from "./ReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./ReceiptTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__